import { getClientInitials, getClientLogoSrc } from "./clientUtils";
import imagePlusIcon from "../../../static/assets/image_plus.png";

const ClientLogo = ({
  client,
  size = 36,
  className = "",
  usePlaceholder = false,
  previewSrc = null,
}) => {
  const src =
    previewSrc && typeof previewSrc === "string"
      ? previewSrc
      : getClientLogoSrc(client?.logoUrl);
  const dimension = { width: size, height: size };
  const initialsClass =
    size >= 72 ? "text-lg" : size >= 48 ? "text-sm" : "text-xs";

  if (!src && usePlaceholder) {
    const placeholderIconSize = size >= 72 ? 32 : size >= 48 ? 24 : 18;

    return (
      <img
        src={imagePlusIcon}
        alt=""
        className="object-contain w-[84px] h-[84px]"
        style={{
          width: placeholderIconSize,
          height: placeholderIconSize,
        }}
      />
    );
  }

  if (src) {
    return (
      <img
        src={src}
        alt=""
        className={`shrink-0 rounded-lg object-contain bg-white border border-[#d3d3d3] ${className}`}
        style={dimension}
      />
    );
  }

  return (
    <span
      className={`shrink-0 rounded-lg font-semibold flex items-center justify-center border border-[#d3d3d3] ${initialsClass} ${className}`}
      style={dimension}
      aria-hidden
    >
      {getClientInitials(client?.name)}
    </span>
  );
};

export default ClientLogo;
